import React__default from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useIntl } from '@grandvisionhq/state';
import { mapLensExtraProductsToExtrasItems } from './mappers/map-lens-extra-products-to-extras-items.js';
import { mapProductToFrameData } from './mappers/map-product-to-frame-data.js';
import { mapProductToLensPacks } from './mappers/map-product-to-lens-packs.js';
import SSP from './SSP.js';
import { useProductDetailContext } from '../ProductDetail/Context/ProductDetailContext.js';

const SSPContainer = ({ initialGlasses , lensExtras , lensExtrasResolver , onChange  })=>{
    const { product , productType  } = useProductDetailContext();
    const { locale  } = useIntl();
    if (!CommerceToolsApi.isFrames(productType) || !(lensExtras === null || lensExtras === void 0 ? void 0 : lensExtras.length)) return null;
    const frameData = mapProductToFrameData(product);
    const lensPackData = mapProductToLensPacks(product, frameData.isKidsGlasses, locale);
    const { monofocalExtras , multifocalExtras  } = mapLensExtraProductsToExtrasItems(lensExtras, locale);
    return /*#__PURE__*/ React__default.createElement(SSP, {
        frameData: frameData,
        lensPackData: lensPackData,
        monofocalExtras: monofocalExtras,
        multifocalExtras: multifocalExtras,
        initialGlasses: initialGlasses,
        lensExtrasResolver: lensExtrasResolver,
        useIncludedFrame: false,
        useIncludedLensPack: true,
        onChange: onChange
    });
};

export { SSPContainer };
//# sourceMappingURL=SSPContainer.js.map
